export enum BadgeLabelMenuEnum {
  COMINGSOON = "comingSoon",
  RECOMMEND = "Recommend",
}
